import cx from 'classnames';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconTrendingUp } from '@blocks-react/components/Icons/TrendingUp';
import { CatTextLink } from '@blocks-react/components/TextLink';
import { PAGE_BREAKPOINTS } from '../../../constants/commonConstants';
import { useBreakpoint } from '../../../hooks';
import { ServiceInsightButtonProps } from '../types';
import styles from './serviceInsightButton.module.scss';

export const ServiceInsightButton = ({
  onClick,
  isLargeIcon = true,
  children,
  classname
}: ServiceInsightButtonProps) => {
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  return (
    <CatButton
      variant="ghost"
      onClick={onClick}
      className={cx(
        styles['serviceInsightButton'],
        {
          'mt-3': !isLargeIcon
        },
        classname
      )}
    >
      <CatTextLink size="sm" className={styles['serviceInsightButton_text']}>
        {children}
      </CatTextLink>
      <CatIconTrendingUp
        size={isLG && isLargeIcon ? undefined : 'sm'}
        slot="before"
        data-testid="service-insight-icon"
        className={cx(styles['serviceInsightButton_icon'], {
          [styles['serviceInsightButton_icon--large']]: isLG && isLargeIcon
        })}
      />
    </CatButton>
  );
};
